/** html2canvas 오프스크린 캡처용 — 화면 CSS와 동일한 테이블·메타 스타일 */
export const ANNUAL_CROSS_TOPIC_DETAIL_CAPTURE_CSS = `
[data-theme='light'] .cp-annual-cross-topic-detail-subtitle,
.cp-annual-cross-topic-detail-subtitle {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px 12px;
  margin: 0 0 6px;
  font-size: 20px !important;
  font-weight: 700;
  text-align: center;
  color: #111;
  line-height: 1.35 !important;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Noto Sans KR', sans-serif;
}
.cp-annual-cross-topic-detail-scope {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 8px;
  font-size: 17px !important;
  font-weight: 800;
  border: 1px solid transparent;
}
.cp-annual-cross-topic-detail-scope--term1 {
  background: #f3ecee;
  color: #4a383d;
  border-color: rgba(74, 56, 61, 0.22);
}
.cp-annual-cross-topic-detail-scope--term2 {
  background: #ebf0f4;
  color: #2c3a45;
  border-color: rgba(44, 58, 69, 0.22);
}
.cp-annual-cross-topic-detail-scope--annual {
  background: #f7ede4;
  color: #5a3d26;
  border-color: rgba(90, 61, 38, 0.22);
}
.cp-annual-cross-topic-detail-topic {
  color: #111;
  font-size: 20px !important;
  line-height: 1.35 !important;
}
.cp-annual-cross-topic-detail-topic--stacked {
  white-space: normal;
}
.cp-program-export-track-timetable-stack {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  line-height: 1.2;
  text-align: center;
}
.cp-program-export-track-timetable-line {
  display: block;
}
.cp-annual-cross-topic-detail-table-wrap {
  width: 100%;
  overflow: visible;
}
.cp-annual-cross-topic-detail-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 11px;
  line-height: 1.35;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Noto Sans KR', sans-serif;
  color: #111;
  background: #fff;
}
.cp-annual-cross-topic-detail-table th,
.cp-annual-cross-topic-detail-table td {
  border: 1px solid #d8d8d8;
  padding: 6px 7px;
  word-break: break-word;
  background: #fff;
  color: #111;
}
.cp-annual-cross-topic-detail-table td {
  vertical-align: top;
}
.cp-annual-cross-topic-detail-table th {
  background: #f4f4f4;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
}
.cp-annual-cross-topic-detail-col-center {
  text-align: center;
  vertical-align: middle;
}
.cp-annual-cross-topic-detail-th-stacked {
  white-space: normal;
  line-height: 1.15;
  padding: 5px 3px;
}
.cp-annual-cross-topic-detail-th-line {
  display: block;
}
.cp-annual-cross-topic-detail-period-value {
  display: block;
  width: 100%;
  text-align: center;
}
.cp-annual-cross-topic-detail-table th span,
.cp-annual-cross-topic-detail-table td span {
  border: none !important;
  box-shadow: none !important;
}
.cp-annual-cross-topic-detail-table tbody tr:nth-child(even) td {
  background: #f8f8f8;
}
.cp-annual-cross-topic-detail-table th:nth-child(1),
.cp-annual-cross-topic-detail-table td:nth-child(1) { width: 3.5%; text-align: center; vertical-align: middle; }
.cp-annual-cross-topic-detail-table th:nth-child(2),
.cp-annual-cross-topic-detail-table td:nth-child(2) { width: 7%; }
.cp-annual-cross-topic-detail-table th:nth-child(3),
.cp-annual-cross-topic-detail-table td:nth-child(3) { width: 3.5%; padding-left: 4px; padding-right: 4px; }
.cp-annual-cross-topic-detail-table th:nth-child(4),
.cp-annual-cross-topic-detail-table td:nth-child(4) { width: 4%; padding-left: 4px; padding-right: 4px; }
.cp-annual-cross-topic-detail-table th:nth-child(5),
.cp-annual-cross-topic-detail-table td:nth-child(5) { width: 7%; }
.cp-annual-cross-topic-detail-table th:nth-child(6),
.cp-annual-cross-topic-detail-table td:nth-child(6) { width: 10%; }
.cp-annual-cross-topic-detail-table th:nth-child(7),
.cp-annual-cross-topic-detail-table td:nth-child(7) { width: 27%; }
.cp-annual-cross-topic-detail-learning {
  white-space: pre-wrap;
  text-align: left;
}
.cp-annual-cross-topic-detail-table th:nth-child(8),
.cp-annual-cross-topic-detail-table td:nth-child(8),
.cp-annual-cross-topic-detail-table th:nth-child(9),
.cp-annual-cross-topic-detail-table td:nth-child(9) {
  width: 5.5%;
  text-align: center;
}
.cp-annual-cross-topic-detail-table th:nth-child(10),
.cp-annual-cross-topic-detail-table td:nth-child(10),
.cp-annual-cross-topic-detail-table th:nth-child(11),
.cp-annual-cross-topic-detail-table td:nth-child(11) {
  width: 3.8%;
  padding-left: 3px;
  padding-right: 3px;
  text-align: center;
  vertical-align: middle;
}
.cp-annual-cross-topic-detail-table th:nth-child(12),
.cp-annual-cross-topic-detail-table td:nth-child(12) { width: 11%; }
.cp-program-learning-cross-suffix {
  color: #444;
}
.cp-capture-hide-thead thead {
  display: none !important;
}
.cp-capture-hide-tbody tbody {
  display: none !important;
}
`;
